import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import logoImage from '../images/vatsca.svg';
import loginBackgroundImage from '../images/login-background.png';
import { LOGIN_URL } from '../data/config';

const Login = () => {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const message = params.get('message');
    const error = params.get('error');

    if (message === 'logout_success') {
      navigate('/login', { replace: true });
    }

    console.log(error);

    if (error) {
      setErrorMessage('Login error. Please try again. If the problem persists, try clearing your browser cookies.');
    }

    if (user) {
      navigate('/');
    }
  }, [user, location, navigate]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-black text-white">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 animate-spin"></div>
        <p className="mt-4">Checking authentication status...</p>
      </div>
    );
  }

  const handleLogin = () => {
    // Clear any previous error messages when attempting to login again
    setErrorMessage(null);
    window.location.href = LOGIN_URL;
  };

    const clearCookies = () => {
        const cookies = document.cookie.split(';');

        for (let cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        }

        alert('Cookies cleared! You can try logging in again.');
    };

  return (
    <div className="flex h-screen bg-black">
      {/* Background image section - hidden on mobile */}
      <div 
        className="hidden md:flex flex-1 bg-cover bg-left opacity-30"
        style={{ backgroundImage: `url(${loginBackgroundImage})` }} 
      />

      {/* Login content section */}
      <div className="flex-1 flex flex-col items-center justify-center p-8 bg-gray-900 text-white">
        <div className="w-full max-w-md">
          
          <div className="flex flex-col items-center justify-center mb-6">
            <img className="w-[140px] mb-4" src={logoImage} alt="VATSIM Scandinavia" />
            <div className="text-xl font-bold text-gray-300 text-center">
              EFIN General Information Display
            </div>
          </div>
          
          <p className="text-gray-300 mb-6 text-center">
            <p className="text-xs text-yellow-600">For Simulator Use Only on VATSIM Network</p>
            <p className="text-xs text-yellow-600">Minimum S1 rating in SCA Subdivision required</p>
          </p>
          
          {/* Error message display */}
            {errorMessage && (
                <div className="mb-4 p-3 bg-red-900 text-red-200 rounded text-sm">
                    {errorMessage}
                    <button
                        onClick={clearCookies}
                        className="ml-2 text-blue-400 underline text-xs"
                    >
                        Clear cookies
                    </button>
                </div>
            )}
          
          <button 
            onClick={handleLogin}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 transition duration-200 flex items-center justify-center"
          >
            Login with VATSIM
          </button>

          <div className="mt-6 pt-6 border-t border-gray-700 text-center">
            <p className="text-sm text-gray-500">
              <a className='mr-4' href='https://hold.lusep.fi/#/privacy-policy'>Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;